import type { BadgeColor } from '../types';

export type NgNotificationBadgeProps = {
  text?: string;
  color?: BadgeColor;
  textColorClass?: string;
  additionalClasses?: string;
  noMargin?: boolean;
};

const BADGE_COLOR_CLASS: Record<BadgeColor, string> = {
  blue: 'bg-info',
  orange: 'bg-warning',
  black: 'bg-dark',
  red: 'bg-danger',
  green: 'bg-success',
  darkGray: 'bg-secondary',
};

export function NgNotificationBadge({
  text = '',
  color = 'blue',
  textColorClass,
  additionalClasses,
  noMargin = false,
}: NgNotificationBadgeProps) {
  return (
    <span
      className={`badge ${BADGE_COLOR_CLASS[color]} text-white ${noMargin ? '' : 'ms-1'} p-1 ${textColorClass ?? ''} ${additionalClasses ?? ''}`}
    >
      {text}
    </span>
  );
}
